"use client";

import Layout from "@/components/layout/Layout";
import About from "@/components/sections/about/About";
import useMetadataStore from "@/store/metadata.store";

export default function AboutUs() {
  const { data } = useMetadataStore();

  return (
    <>
      <Layout
        pageId={"about-page"}
        activePage={"About Us"}
        pageTitle={`ABOUT Us `}
        headerStyle={1}
        footerStyle={1}
        headTitle={`About Us - ${data?.customer?.name ?? ""}`}
      >
        <About helperCls="" />

      </Layout>
    </>
  )
}
